import axios from 'axios';
import BaseApi from 'Components/api/BaseApi';
import { logOutIfTokenExpired, resultInfo } from 'Components/helpers';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

export function useDownloadSimpleCvPdf(
   simpleCvId: number,
   isOpenContact: boolean,
   {
      token,
      apiKey,
      onSuccess,
      onError,
   }: {
      token: string;
      apiKey: string;
      onError?: () => void;
      onSuccess?: (data: any) => void;
   }
) {
   const { t } = useTranslation('global');

   const [loading, setLoading] = useState(false);
   const navigate = useNavigate();
   const onDownloadPdf = async () => {
      if (!isOpenContact) {
         return resultInfo(
            'warning',
            t('jobseekerManageAlert.contactsError'),
            t('jobseekerManageAlert.close')
         );
      }

      try {
         setLoading(true);

         const response = await axios.post(
            BaseApi + '/download-simple-user-pdf',
            {
               id: simpleCvId,
               contacts: true,
            },
            {
               headers: {
                  key: apiKey,
                  token: token,
                  contentType: 'multipart/form-data',
                  'Content-Type': 'multipart/form-data',
               },
               responseType: 'blob',
            }
         );

         setLoading(false);

         if (response.status === 200) {
            console.log(typeof response.data);
            onSuccess?.(response.data);
         } else {
            Swal.fire({
               icon: 'error',
               text: response.data.message,
               title: t('employerFavouriteList.createFolderFailedTitle'),
               confirmButtonText: t('employerFavouriteList.close'),
            });
            onError?.();
         }
      } catch (error: any) {
         setLoading(false);

         if (error.response.status === 400) {
            resultInfo(
               'warning',
               t('jobseekerManageAlert.contactsError'),
               t('jobseekerManageAlert.close')
            );
         } else {
            resultInfo(
               'error',
               t('jobDescription.unsubscribeError'),
               t('jobseekerManageAlert.close')
            );
         }

         if (
            error.message === 'Network Error' ||
            error.response.data.message === 'Token has expired'
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         } else {
            Swal.fire({
               icon: 'error',
               text: t('employerFavouriteList.folderFailedTxt'),
               confirmButtonText: t('employerFavouriteList.close'),
               title: t('employerFavouriteList.createFolderFailedTitle'),
            });
         }

         console.error("Couldn't create the folder!", error);
      }
   };

   return { onDownloadPdf, loadingPdf: loading };
}
